import React from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";

import { buttonName, monthlyKPIReportsData } from "../../locales/en";
import "./modalstyle.scss";

const AIInsightsModal = ({ isOpen, toggle }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={monthlyKPIReportsData?.downloadModal?.refreshAIReport}
      modalClassName="modal-dialog"
      footerButtons={[
        {
          label: buttonName.close,
          className: "btn btn-secondary",
          onClick: toggle
        }
      ]}
    >
      <div className="row">
        <div className="col-12">
          <p>
            <strong>{monthlyKPIReportsData?.downloadModal?.text9}</strong>
          </p>
          <p>{monthlyKPIReportsData?.downloadModal?.text5}</p>
        </div>
      </div>
    </CommonModal>
  );
};

AIInsightsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default AIInsightsModal;
